import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import areSameSpecs from '@/utils/Common/Compare/areSameSpecs';

const ComparePopupContentResultsAccordion = ({
  productsCode,
  content,
  showDifferences,
  titleLabel,
}) => {
  const [isChecked, setIsChecked] = useState(true);
  if (_isEmpty(content)) return null;
  if (
    showDifferences &&
    Object.keys(content).every(val => areSameSpecs(productsCode, content[val]))
  )
    return null;
  return (
    <section className='ken-simple-css-accordion'>
      <input
        type='checkbox'
        id={titleLabel}
        checked={isChecked}
        onChange={() => {
          setIsChecked(!isChecked);
        }}
      />
      <div className='ken-simple-css-accordion__wrapper'>
        <label htmlFor={titleLabel} className='ken-simple-css-accordion__title'>
          <h4>{titleLabel}</h4>
          <i className='ken-simple-css-accordion__icon-desktop' />
        </label>
        <div className='ken-simple-css-accordion__content-desktop'>
          {Object.keys(content).map(item => {
            const sameSpecs = areSameSpecs(productsCode, content[item]);
            if (showDifferences && sameSpecs) return null;
            return (
              <section
                key={item}
                className={`--inner-content ${sameSpecs ? '' : ' --different'}`}
              >
                <section className='--label'>
                  <span>{item}</span>
                </section>
                {productsCode.length === 2 && <span className='--data' />}
                {productsCode.map(product => {
                  const currData = content[item][product];
                  return (
                    <section key={product} className='--data --fill'>
                      <span>
                        {currData === 'true' ? (
                          <i
                            className={`ken-icon ken-icon--check-${
                              sameSpecs ? 'black' : 'red'
                            }`}
                          />
                        ) : (
                          currData
                        )}
                      </span>
                    </section>
                  );
                })}
              </section>
            );
          })}
        </div>
      </div>
    </section>
  );
};

ComparePopupContentResultsAccordion.propTypes = {
  productsCode: PropTypes.arrayOf(PropTypes.string),
  content: PropTypes.shape(),
  showDifferences: PropTypes.bool,
  titleLabel: PropTypes.string.isRequired,
};

ComparePopupContentResultsAccordion.defaultProps = {
  productsCode: [],
  showDifferences: false,
  content: {},
};

export default ComparePopupContentResultsAccordion;
